import React, { useEffect } from 'react'
import { Button } from '@intelie/ui'

import i18n from 'live/services/i18n'

import { Template } from '../../../types'
import { TemplateActionsContainer, TemplateActionsDropdownContainer } from '../../styles'

interface ListActionsProps {
    template: Template
    handleDuplicate: (template: Template) => void
    handleDelete: (template: Template) => void
}

const ListActions: React.FC<ListActionsProps> = ({ template, handleDelete, handleDuplicate }: ListActionsProps) => {
    const [openActionsDropdown, setOpenActionsDropdown] = React.useState(false)

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent): void => {
            if (!(event.target as HTMLElement).closest('.template-actions')) {
                setOpenActionsDropdown(false)
            }
        }

        document.addEventListener('click', handleClickOutside)

        return (): void => {
            document.removeEventListener('click', handleClickOutside)
        }
    }, [])

    return (
        <TemplateActionsContainer>
            <Button onClick={() => setOpenActionsDropdown(true)} className="actions-trigger" variant="text">
                <i className="fas fa-ellipsis-v" />
            </Button>
            {openActionsDropdown && (
                <TemplateActionsDropdownContainer>
                    <Button variant="text" onClick={() => handleDuplicate(template)} icon="copy">
                        {i18n('Duplicate')}
                    </Button>
                    <Button variant="text" onClick={() => handleDelete(template)} icon="trash-alt">
                        {i18n('Remove')}
                    </Button>
                </TemplateActionsDropdownContainer>
            )}
        </TemplateActionsContainer>
    )
}

export default ListActions
